import { schema } from 'normalizr';

export const leadAttributeSchema = new schema.Entity('leadAttribute');
